import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router";
import { ReactSVG } from "react-svg";
import useBranding from "../../../../hooks/useBranding";
import {
  down_arrow,
  image1,
  logout_image,
  notification,
  profile_image,
  Regenerate_course_image,
} from "../../../../assets/images/images";
import "../../styles/dashboard.css";
import { Grid } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { cartList, resetCartList, clearPaymentFlag } from "../../../../state/actions/cartlistAction";
import { useDispatch, useSelector } from "react-redux";
import api from "../../../../api/api";
import imgs from "../../../../assets/images/imgs";
import StyledMenu from "../../../../components/StyleMenu";
import AdminUniversalSearch from "../../../../components/UniversalSearch/AdminUniversalSearch";
import UniversalSearch from "../../../../components/UniversalSearch/UniversalSearch";
import { useAuth } from "../../../../features/auth/AuthContext";
import { getProfileDetails } from "../../../../state/actions/getProfileDetailsAction";
import { getDataList } from "../../../../state/actions/getdataListAction";
import {
  getGoogleTokenAction,
  resetGoogleToken,
} from "../../../../state/actions/getGoogleTokenAction";
import { updateGlobalState } from "../../../../state/global/slice";
import {
  setSyncSchoologydtls,
  resetSyncSchoology,
} from "../../../../state/actions/syncSchoologyAction";
import { toast } from "react-toastify";
import {
  syncToGoogleDrive,
  resetgoogleDriveSync,
} from "../../../../state/actions/googleDriveSyncAction";
// "Book a meeting" (students) / "My meetings" (teachers). The button label and
// the Google Calendar connect flow are handled inside the component itself.
import { BookAMeetingButton } from "../../../../components/BookAMeeting/BookAMeeting";
import { convertTo12Hour } from "../../../../components/BookAMeeting/meetingUtils";
import { HeaderHamburger } from "./student/Icons/Icons";
import { useSidebarDrawer } from "../../../../context/SidebarDrawerContext";

const Dashboardheader = (props) => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const hideHeaderRoutes = [
    "/login",
    "/signup",
    "/",
    "/about",
    "/contact",
    "/features",
    "/admin",
    "/admin-signup",
    "/terms-and-conditions",
    "/privacy-policy",
  ]; // Add routes where you want to hide the header
  const shouldHideHeader = (pathname) => {
    // Check if the pathname is exactly one of the predefined routes
    if (hideHeaderRoutes.includes(pathname)) return true;
    return false;
  };
  const showHeader = !shouldHideHeader(location.pathname);
  const globalState = useSelector((state) => state.globalState);
  const datalist = useSelector((state) => state.getdatalist);
  const { profileDetails } = useSelector((state) => state.profileDetails);
  const googledriveSync = useSelector((state) => state.googleDriveSync);
  const [showDrive, setshowDrive] = useState("");
  const [callingApi, setCallingApi] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const { message, isLoading, error } = useSelector(
    (state) => state.syncSchoology
  );
  const navigate = useNavigate();
  const branding = useBranding();
  const { logout, token } = useAuth();
  const [getlastupdatedschoology, setGetlastupdatedschoology] = useState();
  const dispatch = useDispatch();
  const subadmin_details = globalState.subadmin_details;

  // Cart (marketplace-gated)
  const isMarketplace = globalState.enabled_modules?.includes('marketplace');
  const addToCartData = useSelector((state) => state.addToCart);
  const cartlistData = useSelector((state) => state.cartlist);
  const removeCart = useSelector((state) => state.removeCartData);
  const [cartLength, setcartLength] = useState(0);
  const teacherRole = globalState?.teacher_details?.data?.teacher_department_roles || globalState?.role;
  const capitalizedTeacherRole = teacherRole?.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
  const isGoogleMeet = globalState.enabled_modules?.includes('google_meet');

  const profileFirstName =
    location.state?.role === "Student" || globalState?.role === "Student"
      ? location.state?.student_details?.data?.name ??
      globalState?.student_details?.data?.name ??
      location.state?.role ??
      globalState?.role
      : location.state?.role === "Teacher" || globalState?.role === "Teacher"
        ? location.state?.teacher_details?.data?.name ??
        globalState?.teacher_details?.data?.name
        : location.state?.role ?? globalState?.role;

  const profileimage =
    location.state?.role === "Student" || globalState?.role === "Student"
      ? location.state?.student_details?.data?.ai_avatar ??
      globalState?.student_details?.data?.ai_avatar ??
      location.state?.role ??
      globalState?.role
      : location.state?.role === "Teacher" || globalState?.role === "Teacher"
        ? location.state?.teacher_details?.data?.ai_avatar ??
        globalState?.teacher_details?.data?.ai_avatar
        : location.state?.role ?? globalState?.role;

  const profileNameInitial = (name) => {
    return String(name)
      ?.split(" ")
      .map((n) => n[0])
      .join("");
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // Mobile hamburger: only rendered where a sidebar drawer is mounted, so it
  // never opens the profile menu it sits inside.
  // Visibility follows the mounted drawer's breakpoint (1200px on the
  // dashboards), not a fixed Tailwind breakpoint.
  const { openDrawer, isDrawerActive } = useSidebarDrawer();
  const handleHamburgerClick = (event) => {
    event.stopPropagation();
    handleClose();
    openDrawer();
  };
  // const onsyncSchoology = () => {
  //   dispatch(setSyncSchoologydtls(token));
  // };
  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };

  // Cart fetch (marketplace only)
  const cartListRequest = () => {
    if (isMarketplace && token) dispatch(cartList(token));
  };
  useEffect(() => {
    if (isMarketplace) cartListRequest();
  }, [removeCart, addToCartData]);
  useEffect(() => {
    if (isMarketplace && cartlistData?.cartList) {
      setcartLength(cartlistData.cartList.length);
    }
  }, [cartlistData]);

  useEffect(() => {
    if (globalState.role === "Student" && token !== null) {
      dispatch(getProfileDetails(token));
    }
  }, [globalState.role, token]);

  useEffect(() => {
    if (profileDetails !== null) {
      updateState("student_details", profileDetails ?? {});
    }
  }, [profileDetails]);

  useEffect(() => {
    if (!token) return;
    const fetchGradeList = async () => {
      try {
        const response = await api.get("/courses/get-grade-list/", {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        });
        if (response?.status === 200 && response?.data) {
          updateState("grade_details", response.data);
        }
      } catch (error) {
      }
    };

    fetchGradeList();
  }, [token]);

  function handleLogout() {
    // logout() is async and ends in window.location.replace, so it must be
    // called exactly once — a second concurrent call races the first and
    // whichever resolves last wins the redirect.
    localStorage.clear();
    sessionStorage.clear();

    if (globalState.role === "SuperAdmin") {
      logout("/superadmin-login");
      /* navigate("/superadmin-login", { replace: true }); */
    } else if (globalState.role === "Admin") {
      logout("/admin");
      /* navigate("/admin", { replace: true }); */
      return;
    } else {
      logout("/login", true);
      /* navigate("/login", { replace: true }); */
    }

    //window.location.replace(redirectPath);
  }


  useEffect(() => {
    if (globalState?.my_notifications && Array.isArray(globalState.my_notifications)) {
      setNotifications(globalState.my_notifications);
    }
  }, [globalState?.my_notifications]);

  const [showNotification, setShowNotification] = useState(false);
  const OnNotification = () => {
    setShowNotification(!showNotification);
    
  };
  const closeNotification = () => {
    setShowNotification(false);
  };

  useEffect(() => {
    if (datalist) {
      updateState("datalist", datalist.dataList ?? {});
    }
  }, [datalist]);
  const isUnreadNotification = (notificationId) => {
    const isUnread = notifications.some(unread => unread.id === notificationId);
    return isUnread;
  };
  const getNotificationList = () => {
    navigate("/notification-page", {
      state: {
        unreadNotifications: notifications // Pass unread notifications
      }
    });
    closeNotification();
  };

  useEffect(() => {
    // Define an async function inside useEffect
    const fetchData = async () => {
      setCallingApi(false);
      try {
        const response = await api.get(`notifications/notifications_list/`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        });
        if (response.status === 200 || response.status === 201) {
          const actualNotifications = response.data.filter((item) => item.id);

          setNotifications(actualNotifications);
          updateState("my_notifications", actualNotifications);
        } else {
          console.error("Fetch error:", response);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

    if (
      (globalState?.teacher_details || globalState?.student_details) &&
      callingApi
    ) {
      fetchData();
    }
  }, [token, globalState?.teacher_details, globalState?.student_details]);

  useEffect(() => {
    if (token) {
      dispatch(getDataList(token));
      if (globalState?.role !== "Student") {
        dispatch(getGoogleTokenAction(token));
      }
    }
  }, [token]);

  useEffect(() => {
    const failedErrorMessage =
      "Oops, something went wrong. Please try again later.";

    if (message) {
      toast.success(
        "Data synchronization with Schoology is in progress. You will be notified when the process is complete.",
        {
          position: "top-center",
        }
      );
      api
        .get("/auth/get-teacher/", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response?.data) {
              setGetlastupdatedschoology(
                response?.data?.data?.last_schoology_sync
              );

              updateState("teacher_details", response?.data ?? {});
              if(response?.data?.currency_symbol) {
              updateState("currency_symbol", response?.data?.currency_symbol)
              }

            }
          }
        })
        .catch((error) => { });
    } else if (error) {
      toast.error(error || failedErrorMessage, {
        position: "top-center",
      });
      dispatch(resetSyncSchoology());
    }
    return () => {
      dispatch(resetSyncSchoology());
    };
  }, [message, error]);

  const syncToDrive = () => {
    dispatch(syncToGoogleDrive(token));
  };

  useEffect(() => {
    if (googledriveSync?.message) {
      toast.success(
        "Uploading is in progress; We will notify you once it is completed.",
        {
          position: "top-center",
        }
      );
    }
    if (googledriveSync?.error) {
      toast.error("Please connect to your Google Drive", {
        position: "top-center",
      });
    }

    return () => {
      dispatch(resetgoogleDriveSync());
    };
  }, [googledriveSync]);

  useEffect(() => {
    setshowDrive(
      location.pathname.split("/")[location.pathname.split("/").length - 1]
    );
  }, [location.pathname]);

  const forceExitFullscreen = () => {
    // Check if we're actually in fullscreen
    const isFullscreen = !!(
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    );

    if (!isFullscreen) {
      return;
    }

    // Try all methods
    const exitMethods = [
      () => document.exitFullscreen && document.exitFullscreen(),
      () => document.webkitExitFullscreen && document.webkitExitFullscreen(),
      () => document.mozCancelFullScreen && document.mozCancelFullScreen(),
      () => document.msExitFullscreen && document.msExitFullscreen(),
    ];

    exitMethods.forEach((method, index) => {
      try {
        const result = method();
        if (result && typeof result.then === "function") {
          result.catch((err) => { }
          );
        }
      } catch (error) {
      }
    });
  };

  // Delayed exit fullscreen with retry
  const delayedExitFullscreen = () => {
    // Try immediately
    forceExitFullscreen();

    // Try again after 500ms
    setTimeout(() => {
      const stillFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );

      if (stillFullscreen) {
        forceExitFullscreen();
      }
    }, 500);

    // Final attempt after 1000ms
    setTimeout(() => {
      const stillFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );

      if (stillFullscreen) {
        forceExitFullscreen();
      }
    }, 1000);
  };
  const notificationWrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationWrapperRef.current && !notificationWrapperRef.current.contains(event.target)) {
        setShowNotification(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const isOnNotificationPage = location.pathname === "/notification-page";

  return showHeader ? (
    <Grid
      id="dashboardHeader-container"
      sx={{
        position: "sticky",
        top: "0px",
        left: "0px",
        right: "0px",
        margin: "auto",
        backgroundColor: "white",
        zIndex: "4",
      }}
    >
      <div className="dashboardHeader">
        <div className="dashboardSearch">
          <h2
            className="dashboardHeaderText"
            onClick={() => {
              delayedExitFullscreen();
            }}
          >
            <NavLink to="/">
              <div className="logo">
                <img src={branding.logo || image1} alt="logo" />
              </div>
            </NavLink>
          </h2>
          {location.state?.role === "Admin" || globalState?.role === "Admin" ? (
            <AdminUniversalSearch />
          ) : (
            <UniversalSearch />
          )}
        </div>
        <div className="dashboardHeaderProfile"> </div>
        <div className="dashboardHeaderProfile" style={{ cursor: "unset" }}>
          {location.state?.role === "Student" ||
            globalState?.role === "Student" ||
            location.state?.role === "Teacher" ||
            globalState?.role === "Teacher" ? (
            <>
              {/* Book a meeting (student) / My meetings (teacher).
                  Google Calendar connect is handled inside the modal's
                  Integrations tab, so no separate connect button here.
                  Hidden on mobile as it's available in the sidebar. */}
             {isGoogleMeet && !isMobile && (
               <BookAMeetingButton className="dashboard-book-meeting" />
             )} 

              {/* Cart icon (marketplace + student only) */}
              {isMarketplace && globalState?.role === "Student" && (
                <span className="add-cart" style={{ cursor: "pointer", position: "relative", marginRight: "15px" }} onClick={() => navigate("/cart")}>
                  <i className="fa-solid fa-cart-shopping" style={{ fontSize: "20px" }}></i>
                  {cartLength > 0 && (
                    <span style={{
                      position: "absolute", bottom: 10, left: 10,
                      height: "20px", width: "20px", backgroundColor: "#0d6efd",
                      borderRadius: "50%", border: "1px solid white", color: "#ffffff",
                      textAlign: "center", display: "flex", justifyContent: "center",
                      alignItems: "center", fontSize: "11px", top: "1px"
                    }}>
                      {cartLength}
                    </span>
                  )}
                </span>
              )}
              <div style={{ position: "relative" }} className="cursor-pointer" onClick={OnNotification}>
                <ReactSVG src={notification} />
                {notifications?.length > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: 10,
                      left: 10,
                      height: "25px",
                      width: "25px",
                      backgroundColor: "red",
                      borderRadius: "50%",
                      border: "1px solid white",
                      color: "#ffffff",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "11px",
                    }}
                  >
                    {notifications?.length}
                  </span>
                )}
              </div>
            </>
          ) : (
            <></>
          )}
          <div className="profile-wrapper" onClick={handleClick}>
            <p className="dashboardHeaderProfileNameInitial">
              {profileNameInitial(profileFirstName)}
            </p>
            <div className="dashboardHeaderName">
              <p className="dashboardHeaderProfileText">{teacherRole !== "Admin" ? profileFirstName : "Admin"}</p>
              <p className="dashboardHeaderTeacherRole">{teacherRole === "hod" ? "Head Of Department" : capitalizedTeacherRole}</p>
            </div>
            {!isDrawerActive && (
            <span className = 'hidden sm:!inline-block'>
            <ReactSVG
              id="demo-customized-button"
              aria-controls={open ? "demo-customized-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              src={down_arrow}
              />
              </span>
            )}

              {isDrawerActive && (
              <span
                className="inline-block cursor-pointer"
                role="button"
                tabIndex={0}
                aria-label="Open menu"
                onClick={handleHamburgerClick}
              >
                <HeaderHamburger />
              </span>
              )}
          </div>
          <StyledMenu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            slotProps={{
              paper: {
                minWidth: 180,
                elevation: 0,
                sx: {
                  overflow: "visible",
                  // filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    w0idth: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 4,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            {(location.state?.role === "Student" ||
              globalState?.role === "Student" ||
              location.state?.role === "Teacher" ||
              globalState?.role === "Teacher") && (
                <MenuItem
                  onClick={() => {
                    navigate("/settings");
                    handleClose();
                  }}
                  disableRipple
                >
                  <button type="button" className="profile-menu-header">
                    <ReactSVG src={profile_image} />
                    <p>Profile</p>
                  </button>
                </MenuItem>
              )}
            <MenuItem onClick={handleLogout} disableRipple>
              <button type="button" className="profile-menu-header">
                <ReactSVG src={logout_image} />
                <p>Logout</p>
              </button>
            </MenuItem>
          </StyledMenu>
          {showNotification && (
            <div
              ref={notificationWrapperRef}
              onMouseLeave={closeNotification}
              className="notifications-wrapper"
            >
              <div className="notifications-container">
                <div className="notifications-title">
                  <ReactSVG src={notification} />
                  <p>Notifications</p>
                </div>
                <div
                  className="notifications-all-container-wrapper"
                  style={{
                    alignItems: "flex-start",
                    height:
                      notifications?.length > 0
                        ? notifications?.length * 110
                        : "100px",
                  }}
                >
                  <div className="notifications-all-container">
                    {notifications?.length > 0 ? (
                      notifications
                        ?.filter((notification) => notification.id)
                        ?.map((notification, index) => (
                          <NotificationsCard
                            profileimage={profileimage}
                            notification={notification}
                            notifications={notifications}
                            setNotifications={setNotifications}
                            key={index}
                            closeNotification={closeNotification}
                            isUnreadNotification={isUnreadNotification}
                          />
                        ))
                    ) : (
                      <>There are no notifications</>
                    )}
                  </div>
                </div>
                <div
                  className="notification-view-all-btn"
                  onClick={!isOnNotificationPage ? getNotificationList : undefined}
                  style={{
                    pointerEvents: isOnNotificationPage ? "none" : "auto",
                    opacity: isOnNotificationPage ? 0.5 : 1,
                    color: isOnNotificationPage ? "#555" : "#0068FF",
                    cursor: isOnNotificationPage ? "not-allowed" : "pointer",
                  }}
                >
                  View All
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <hr />
    </Grid>
  ) : (
    <></>
  );
};
const NotificationsCard = ({
  notification,
  notifications,
  key,
  setNotifications,
  closeNotification,
  isUnreadNotification,
  profileimage,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useAuth();
  const dispatch = useDispatch();
  const globalState = useSelector((state) => state.globalState);
  const isTeacher = globalState.role === "Teacher";
  const id = notification.id;
  const isUnread = isUnreadNotification(notification.id);
  const isMarketplace = globalState.enabled_modules.includes("marketplace");

  const convertNotificationTimeTo12Hour = (message) => {
    // Match time patterns like "11:30" or "14:45" and convert to 12-hour format using existing utility
    return message.replace(/\b(\d{1,2}):(\d{2})\b/g, (match) => {
      return convertTo12Hour(match);
    });
  };

  const readNotification = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      };
      const payload = { notification_id: id };

      const response = await api.post(
        `notifications/notifications_list/`,
        payload,
        { headers }
      );

      if (response.status === 200 || response.status === 201) {
        //  Update both local and global state
        const updatedNotifications = notifications.filter((item) => item.id !== id);
        setNotifications(updatedNotifications);

        //  Update global state
        dispatch(updateGlobalState({
          key: "my_notifications",
          value: updatedNotifications
        }));
        closeNotification();

        // Check if it's a meeting notification based on category
        if (notification.category === "meeting") {
          // Helper function to parse date from notification message
          const parseDateFromMessage = (msg) => {
            // Match patterns like "04 Sep 2026" or "Sep 04 2026"
            const dateMatch = msg.match(/(\d{1,2})\s+(\w+)\s+(\d{4})/);
            if (dateMatch) {
              try {
                return new Date(`${dateMatch[1]} ${dateMatch[2]} ${dateMatch[3]}`);
              } catch (e) {
                return null;
              }
            }
            return null;
          };

          // Determine if meeting is in history (cancelled/completed/past date) or upcoming
          const msg = notification.notification_message?.toLowerCase() || "";
          const meetingDate = parseDateFromMessage(notification.notification_message || "");
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const isPastDate = meetingDate && meetingDate < today;
          const isCancelledOrCompleted =
            msg.includes("cancel") ||
            msg.includes("completed") ||
            msg.includes("finish") ||
            notification.is_accepted === false ||
            notification.status === 2 || // completed
            notification.status === 3 || // cancelled
            notification.booking_status === "cancelled" ||
            notification.booking_status === "completed" ||
            isPastDate;

          const activeTab = isCancelledOrCompleted ? "history" : "upcoming";
          console.log("Meeting notification:", { notification, isCancelledOrCompleted, activeTab, meetingDate, isPastDate });
          navigate("/dashboard/meetings", {
            replace: true,
            state: {
              activeTab: activeTab,
              highlightMeetingId: notification.booking_id || notification.meeting_id || notification.id
            }
          });
        } else if (notification.course_id) {
           if(!isMarketplace){
             const targetPath = isTeacher
            ? `/course/${notification.course_id}/view`
            : notification.is_accepted
            ? `/course/${notification.course_id}`
            : `/course/${notification.course_id}/view`;

          navigate(targetPath, {
            state: {
              course_id: notification.course_id,
              from: "notification",
              course: { course_id: notification.course_id },
            },
            replace: false,
          });
          }else {
              const targetPath = isTeacher
            ? `/course/${notification.course_id}/view`
            : notification.is_accepted
            ? `/course/${notification.course_id}`
            : `/course/${notification.course_id}/view`;

          navigate(targetPath, {
            state: {
              course_id: notification.course_id,
              from: "notification",
              course: { course_id: notification.course_id },
            },
            replace: false,
          });
          }
        } else {
          let alternativePath = null;

          if (notification.notification_type) {
            switch (notification.notification_type) {
              case "assignment":
              case "lesson":
                if (notification.lesson_id) {
                  alternativePath = `/lesson/${notification.lesson_id}`;
                }
                break;
              case "message":
              case "chat":
                alternativePath = "/dashboard/messages";
                break;
              case "profile":
              case "account":
                alternativePath = "/settings";
              case "withdrawal":
              alternativePath ="/revenue-details";
              break;
              case "purchase":
              alternativePath =`/course/${notification.course_id}`;
                break;
              default:
            }
          }

          if (notification.target_url) {
            alternativePath = notification.target_url;
          }

          if (alternativePath) {
            navigate(alternativePath, { replace: true });
          } else {
            navigate("/dashboard/home", { replace: true });
          }
        }
      } else {
      }
    } catch (error) {
    }
  };
  const classNames = `notifications-folder ${isUnread ? 'unread-notification' : ''}`;

  return (
    <div
      className={classNames}
      key={key}
      onClick={readNotification}
      disabled={!id}
      data-notification-id={notification.id}
      data-is-unread={String(isUnread)}
    >
      <div className="notifications-inner-folder">
        <div className="notifications-image">
          <img
            src={
              !notification.profile_pic
                ? profileimage
                  ? profileimage
                  : imgs.png.student_list_logo
                : notification?.profile_pic
            }
            alt=""
          />
        </div>
        <p>{convertNotificationTimeTo12Hour(notification?.notification_message)}</p>
      </div>
      <div className="notification-time-folder">
        <span>{notification?.time}</span>
        <span>{notification?.datetime}</span>
      </div>
    </div>
  );
};
export default Dashboardheader;